import { EventResultsUiConfig } from '../constants/eventPageUiTypes';

const DEFAULT_VISIBLE_EVENT_COUNT = 20;

export const getTargetVisibleEventCount = ({
  page,
  config,
}: {
  page: number;
  config?: EventResultsUiConfig;
}) => {
  if (config?.showAllEventsByDefault) {
    return Number.POSITIVE_INFINITY;
  }

  const showMoreIncrement =
    config?.showMoreIncrement ?? DEFAULT_VISIBLE_EVENT_COUNT;
  const initialVisibleCount = config?.initialVisibleCount ?? showMoreIncrement;

  return initialVisibleCount + (page - 1) * showMoreIncrement;
};

export const shouldContinueFetchingVisibleEvents = ({
  visibleCount,
  targetVisibleCount,
  hasMorePages,
}: {
  visibleCount: number;
  targetVisibleCount: number;
  hasMorePages: boolean;
}) => {
  if (!hasMorePages) {
    return false;
  }

  if (targetVisibleCount === Number.POSITIVE_INFINITY) {
    return true;
  }

  return visibleCount < targetVisibleCount;
};

export const buildAllLocationsHeaderText = ({
  visibleCount,
  totalEntries,
  config,
}: {
  visibleCount: number;
  totalEntries: number;
  config?: EventResultsUiConfig;
}) => {
  if (config?.headerMode === 'visibleCountOfTotal') {
    return `Showing ${visibleCount} of ${totalEntries} events in all locations`;
  }

  if (config?.headerMode === 'visibleCountOnly') {
    return `Showing ${visibleCount} events in all locations`;
  }

  return totalEntries > visibleCount
    ? `Showing ${visibleCount} of ${totalEntries} events in all locations`
    : `${visibleCount} events in all locations`;
};
